import React from 'react';
import { motion } from 'framer-motion';
import { DollarSign, Clock, Smartphone } from 'lucide-react';
const stats = [{
  icon: DollarSign,
  value: '$100-$500 USD',
  label: 'Por cada venta cerrada'
}, {
  icon: Clock,
  value: '15 minutos',
  label: 'Conversaciones cortas, alto impacto'
}, {
  icon: Smartphone,
  value: 'Desde tu celular',
  label: 'Trabaja desde cualquier lugar'
}];
export function SolutionSection() {
  return <section className="w-full bg-emerald-secondary py-16 md:py-24" data-id="element-149">
      <div className="max-w-7xl mx-auto px-6" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-151">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gold-primary mb-4" data-id="element-152">
            El secreto: Appointment Setter
          </h2>
          <p className="text-2xl md:text-3xl text-gold-light mb-6 font-semibold" data-id="element-153">
            No son influencers. No graban bailes en TikTok. No invierten en
            inventarios.
          </p>
          <p className="text-xl md:text-2xl text-cream-primary max-w-4xl mx-auto leading-relaxed" data-id="element-154">
            Ellas son el motor oculto de los grandes negocios digitales. Su
            trabajo es simple: Usar la empatía y la calidez natural para
            conectar con personas interesadas en los DMs y agendar una llamada.
            Por cada cliente que el coach cierra, ellas cobran una comisión en
            dólares.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16" data-id="element-155">
          {stats.map((stat, index) => {
          const Icon = stat.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="bg-gold-primary/10 backdrop-blur-sm border-2 border-gold-primary/30 p-8 rounded-2xl text-center" data-id="element-156">
                <div className="w-20 h-20 bg-gold-primary rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-157">
                  <Icon className="w-10 h-10 text-emerald-primary" aria-hidden="true" data-id="element-158" />
                </div>
                <div className="text-4xl md:text-5xl font-bold text-gold-primary mb-3" data-id="element-159">
                  {stat.value}
                </div>
                <p className="text-lg text-cream-primary font-medium" data-id="element-160">
                  {stat.label}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}